import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { GlobalSearchBar } from '@ztechapps/webui.data-tools'
import type { GlobalSearchResult } from '@ztechapps/common.contract'
import { routesDef } from '../../config/routes'

// Map search result modules to routesDef entries
const SEARCH_MODULE_ROUTES = {
  Order: 'OrderItemPage',
  WorkOrder: 'ProductionItemPage',
  Product: 'ProductItemPage',
  Project: 'ProjectItemPage',
  Task: 'TaskItemPage',
  Logistic: 'LogisticItemPage',
  PurchaseOrder: 'PurchaseItemPage',
  Customer: 'CustomerItemPage',
  Company: 'CompanyItemPage',
  Chat: 'ConversationItemPage',
} as const

// The group heading: the API names a group by its module, which reads as code to an operator.
const SEARCH_MODULE_LABELS: Record<string, string> = {
  Chat: 'Conversations',
}

export const GlobalSearchWrapper = () => {
  const navigate = useNavigate()

  const handleResultClick = useCallback(
    (result: GlobalSearchResult) => {
      const routeDefKey = SEARCH_MODULE_ROUTES[result.module as keyof typeof SEARCH_MODULE_ROUTES]
      const routeDef = routesDef[routeDefKey]

      if (routeDef?.altPath) {
        // The conversation detail route resolves threads on the external key, never the
        // database key, so Chat rows navigate on it — mirroring the inbox row links — while
        // every other module keeps its database-key URL.
        const key = result.module === 'Chat' ? (result.externalId ?? result._id) : result._id
        const path = routeDef.altPath({ _id: key })
        navigate(path)
      }
      // Silently ignore if no route definition found - this should not happen in normal operation
    },
    [navigate]
  )

  return (
    <div data-shortcut-target="global-search">
      <GlobalSearchBar onResultClick={handleResultClick} moduleLabels={SEARCH_MODULE_LABELS} />
    </div>
  )
}
